<div class="socio-birthdate-validation">
  <div class="step-header">
    <h3>Validation des dates de naissance</h3>
    <p>Veuillez vérifier et confirmer les dates de naissance de vos socios</p>
  </div>

  <form [formGroup]="form" class="socios-form">
    <div *ngIf="socios.length === 0" class="empty-state">
      <mat-icon>person_off</mat-icon>
      <p>Aucun socio sélectionné</p>
      <p>Veuillez d'abord sélectionner des options pour vos socios</p>
    </div>
    
    <div class="socios-list" *ngIf="isFormReady">
      <div class="socio-item" *ngFor="let socio of socios; let i = index">
        <div class="socio-card">
          <div class="socio-header">
            <div class="socio-info">
              <mat-icon>person</mat-icon>
              <div class="socio-details">
                <h4>{{ socio.prenom }} {{ socio.nom }}</h4>
                <p class="socio-email">{{ socio.mail }}</p>
              </div>
            </div>
          </div>
          
          <div class="socio-form">
            <div class="date-input-container">
              <label class="date-label">Date de naissance</label>
              <input type="date" 
                     [value]="getDateValue(i)"
                     (change)="onDateChange(i, $any($event.target).value)"
                     class="date-input">
              <div class="date-hint">JJ/MM/AAAA</div>
              <div class="date-error" *ngIf="form.get('socio_' + i)?.hasError('required')">
                La date de naissance est requise
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="empty-state" *ngIf="socios.length === 0">
      <mat-icon>person_off</mat-icon>
      <p>Aucun socio trouvé</p>
      <p>Vous devez avoir des socios associés à votre compte pour continuer</p>
    </div>
  </form>
</div>
